<template>
    <div class="main-content-area">
        <div class="main-content-toolbar">
            <v-toolbar :height="50">
                <v-btn icon="mdi-location-enter" size="small" variant="text" :disabled="allowAdd == false"
                    @click="addNewReturnReference" v-tippy="{ content: 'Add a new Return reference' }" help="1"></v-btn>
                <v-btn icon="mdi-location-exit" size="small" variant="text" :disabled="allowAdd == false"
                    @click="addNewReleaseReference" v-tippy="{ content: 'Add a new Release reference' }"></v-btn>
                <v-btn icon="mdi-pencil" size="small" variant="text" :disabled="allowEdit == false" @click="editReference"
                    v-tippy="{ content: 'Edit selected reference' }"></v-btn>
                <v-btn :icon="filterRecords ? 'mdi-delete' : 'mdi-restore'" size="small" variant="text" 
                    :disabled="filterRecords ? !allowDelete : !allowRestore"
                    @click="handleDeleteRestore"
                    v-tippy="{ content: filterRecords ? 'Delete selected reference' : 'Restore selected reference' }"></v-btn>
                <v-btn icon="mdi-reload" size="small" variant="text" :disabled="allowAdd == false"
                    @click="common.reloadHandler(state, data, populateGridWithData)"
                    v-tippy="{ content: 'Reload reference list' }"></v-btn>
                <v-btn icon="mdi-check" size="small" variant="text" :disabled="state.isEditing == 'no'"
                    @click="finishEditingReference" v-tippy="{ content: 'Finish editing reference' }"></v-btn>
                <v-menu :close-on-content-click="true" transition="none">
                    <template v-slot:activator="{ props }">
                        <v-btn icon="mdi-file-delimited-outline" size="small" variant="text" v-bind="props"
                            v-tippy="{ content: 'Export reference list' }"></v-btn>
                    </template>
                    <v-list density="compact">
                        <v-list-item title="Export csv" @click="exportCsv"></v-list-item>
                        <v-list-item title="Export xlsx" @click="exportXlsx"></v-list-item>
                    </v-list>
                </v-menu>
                <v-btn icon="mdi-history" size="small" variant="text" :disabled="allowEdit == false" @click="showHistory"
                    v-tippy="{ content: 'Show change history of the reference' }"></v-btn>
                <v-btn :icon="filterRecords ? 'mdi-filter-remove-outline' : 'mdi-filter-check-outline'" size="small"
                    variant="text" @click="toggleFilter"
                    v-tippy="{ content: filterRecords ? 'Show inactive / deleted references' :'Show only active references' }"></v-btn>
                <v-btn v-if="hasActiveReferenceFilters" size="small" variant="text" prepend-icon="mdi-filter-remove-outline"
                    @click="clearReferenceFilters">
                    Clear filters
                </v-btn>

            </v-toolbar>
            <v-toolbar :height="50">
                <v-btn icon="mdi-help-circle" size="small" variant="text"
                    v-tippy="{ content: 'Activate help system. <br>[ Development in progress ]' }"></v-btn>
                <AppNotifications />
            </v-toolbar>
        </div>
        <div class="main-content-playground">
            <!--Id is important for the few jquery selects that we are doing below in order not to affect another grid-->
            <ag-grid-vue id="referenceGrid" ref="referenceGrid" style="width: 100%; height: 100%;" class="ag-theme-alpine"
                :class="{ 'filters-disabled': !state.gridReady }"
                :columnDefs="columnDefs" :defaultColDef="defaultColDef" :components="components" :rowData="data.rowData"
                :pinnedTopRowData="data.pinnedTopRowData" :gridOptions="gridOptions" :editType="editType"
                @contextmenu="stopEditingOnRightClick">
            </ag-grid-vue>
        </div>

        <div class="main-content-footer">
            <AppMessageNotifications />
            <v-toolbar :height="40" style="width: 80%;">
                <div style="display: flex; justify-content: flex-end; align-items: center; width: 100%; padding-right: 16px;">
                {{ filterRecords ? 'Active' : 'Inactive / Deleted' }} references: {{ totalRecords }} out of {{ state.totalRowCount }}
                </div>
            </v-toolbar>
        </div>

        <DialogNeo dialog-title="Confirm" :show="state.dialog" dialog-width="25%" dialog-height="unset">
            <template #content>
                <v-container>
                    <v-row align="center">
                        <v-col>
                            Are you sure you want to delete the selected references?
                            <div v-for="(item, index) in state.nodesToDelete" :key="index">
                                <!--{{ item.data.reference }}-->
                            </div>
                        </v-col>
                    </v-row>
                    <v-row align="end" justify="center">
                        <v-col align="right">
                            <v-btn color="primary" prepend-icon="mdi-cancel" @click="cancelDeleteReference">
                                <template v-slot:prepend>
                                    <v-icon color="white"></v-icon>
                                </template>
                                Cancel
                            </v-btn>
                            <v-btn color="error" prepend-icon="mdi-delete" @click="confirmDeleteReference"
                                style="margin-left: 15px;">
                                <template v-slot:prepend>
                                    <v-icon color="white"></v-icon>
                                </template>
                                Delete
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-container>
            </template>
            <template #dialog-header-right>
                <v-btn icon="mdi-close-thick" size="small" variant="text" @click="cancelDeleteReference"></v-btn>
            </template>
        </DialogNeo>

        <DialogNeo dialog-title="Confirm Restore" :show="state.restoreDialog" dialog-width="25%" dialog-height="unset" persistent>
            <template #content>
                <v-container>
                    <v-row align="center">
                        <v-col>
                            Are you sure you want to restore the selected reference?
                        </v-col>
                    </v-row>
                    <v-row align="end" justify="center">
                        <v-col align="right">
                            <v-btn color="primary" prepend-icon="mdi-cancel" @click="cancelRestoreReference">
                                <template v-slot:prepend>
                                    <v-icon color="white"></v-icon>
                                </template>
                                Cancel
                            </v-btn>
                            <v-btn color="success" prepend-icon="mdi-restore" @click="confirmRestoreReference"
                                style="margin-left: 15px;">
                                <template v-slot:prepend>
                                    <v-icon color="white"></v-icon>
                                </template>
                                Restore
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-container>
            </template>
            <template #dialog-header-right>
                <v-btn icon="mdi-close-thick" size="small" variant="text" @click="cancelRestoreReference"></v-btn>
            </template>
        </DialogNeo>

        <DialogNeo v-if="state.containersDialog === true" :show=true :dialog-header=false :dialog-footer=false
            dialog-width="90%" dialog-height="90%">
            <template #content>
                <ContainerReferenceList :reference="state.editingReference" @close="closeContainersDialog"
                    @data-update="dataUpdateContainers" />
            </template>
        </DialogNeo>

        <DialogNeo v-if="history.dialog === true" :show=true :dialog-header=false :dialog-footer=false dialog-width="90%"
            dialog-height="90%">
            <template #content>
                <HistoryList :history="history" @close="closeHistoryDialog" />
            </template>
        </DialogNeo>

    </div>
</template>

<script setup>



//IMPORTS
import jQuery from "jquery";
import { inject, ref, reactive, computed, onActivated, onDeactivated, onMounted, onBeforeMount, onBeforeUnmount, nextTick, getCurrentInstance } from 'vue'
import { useAppStore } from '@/stores/app'
import { useReferenceDefinition } from '@/components/aggrid/definitions/useReferenceDefinition';
import { useCommon } from '@/components/aggrid/common/useCommon';
import { useAdvancedAxios } from '@/composables/useAdvancedAxios';
import ContainerReferenceList from '@/components/ContainerReferenceList';
import HistoryList from '@/components/HistoryList';
import { AgGridVue } from "ag-grid-vue3";
import { useKeyboard } from '@/composables/useKeyboard';
import GridTooltip from '@/components/aggrid/GridTooltip';
import _ from 'lodash';



//CONSTANTS
const componentId = getCurrentInstance().uid;
const fields = {
    'reference': ['id', 'reference', 'type', 'freight_kind', 'survey_size_type_id', 'iso_type_ids', 'validity', 'depot_id', 'operator_id', 'leasing_company_id', 'quantity', 'cargo_condition_id', 'booking_category_id', 'transport_status_id', 'created_at', 'updated_at', 'comment', 'container_older', 'container_younger']
};
const components = {
    AgGridVue
};



//REFERENCES
const referenceGrid = ref(null);



//INJECTIONS
const axios = inject('axios');
const dayJs = inject('dayJs');



//VARIABLES
let gridApi = null;
let gridApi2 = ref(null);
let columnApi = null;
let columnApi2 = ref(null);
let deactivatingCellEditors = false;


//CONSTANTS
const $ = jQuery;
const store = useAppStore();
const editType = 'fullRow';
const data = reactive({
    rowData: null,
    pinnedTopRowData: [],
    pinnedBottomRowData: [],
    isoCodes: [],
})
const buffer = 500;
const pageSize = 1000;

const state = reactive({
    newReferences: 0,
    allowUnpin: false,
    isEditing: 'no',
    dialog: false,
    nodesToDelete: [],
    restoreDialog: false,
    nodesToRestore: [],
    isAdding: false,    //While this is true one can't add another reference
    gridReady: false,
    containersDialog: false,
    editingReference: null,
    firstVisibleColumn: null,
    totalRowCount: 0,
    startRow: 0,
    endRow: pageSize,
    infiniteDataLoading: false,
    previousFilterModel: {}, // Store previous filter model state
    isFiltering: false // Flag to prevent count updates during filtering
})
const filterRecords = ref(true);
const totalRecords = ref('...');
let initialReferenceListSessionPreferences = null;

const getReferenceListSessionPreferenceKey = () => {
    const sessionNamespace = store.ensureSessionScope(store.flowSessionScope || store.user.sessionKey || null);
    return `yamaxSession:${sessionNamespace}:referenceList`;
};

const getDefaultReferenceListSessionPreferences = () => {
    return {
        filterModel: {},
        filterRecords: true,
    };
};

const normalizeReferenceListFilterModel = (value) => {
    return _.isPlainObject(value) ? value : {};
};

const getReferenceListSessionPreferences = () => {
    try {
        const raw = sessionStorage.getItem(getReferenceListSessionPreferenceKey());
        if (!raw) {
            return getDefaultReferenceListSessionPreferences();
        }

        const parsed = JSON.parse(raw);
        return {
            filterModel: _.isPlainObject(parsed?.filterModel) ? parsed.filterModel : {},
            filterRecords: typeof parsed?.filterRecords === 'boolean' ? parsed.filterRecords : true,
        };
    } catch (error) {
        return getDefaultReferenceListSessionPreferences();
    }
};

const saveReferenceListSessionPreferences = () => {
    if (!store.user.id) {
        return;
    }

    try {
        sessionStorage.setItem(getReferenceListSessionPreferenceKey(), JSON.stringify({
            filterModel: normalizeReferenceListFilterModel(gridApi ? gridApi.getFilterModel() : state.previousFilterModel),
            filterRecords: !!filterRecords.value,
        }));
    } catch (error) {
        // ignore sessionStorage errors
    }
};

const persistReferenceListSessionPreferences = () => {
    saveReferenceListSessionPreferences();
};

const hasReferenceListSessionFilterModel = (preferences) => {
    return Object.keys(normalizeReferenceListFilterModel(preferences?.filterModel)).length > 0;
};

const hydrateSavedReferenceListSessionPreferences = () => {
    const savedPreferences = getReferenceListSessionPreferences();
    filterRecords.value = savedPreferences.filterRecords;
    return savedPreferences;
};

const applySavedReferenceListSessionPreferences = () => {
    if (!gridApi) {
        return;
    }

    const savedPreferences = hydrateSavedReferenceListSessionPreferences();
    const previousFilterModel = gridApi.getFilterModel() ?? {};
    const hadSavedFilterModel = Object.keys(savedPreferences.filterModel).length > 0;
    const filterRecordsChanged = filterRecords.value !== savedPreferences.filterRecords;
    const filterModelChanged = JSON.stringify(previousFilterModel) !== JSON.stringify(savedPreferences.filterModel);

    if (hadSavedFilterModel && filterModelChanged) {
        state.previousFilterModel = _.cloneDeep(savedPreferences.filterModel);
        gridApi.setFilterModel(savedPreferences.filterModel);
        initialReferenceListSessionPreferences = null;
        return;
    }

    state.previousFilterModel = _.cloneDeep(savedPreferences.filterModel);
    initialReferenceListSessionPreferences = null;

    if (filterRecordsChanged) {
        updatePaginationParams(0, pageSize);
        populateGridWithData();
    }
};

const updatePaginationParams = (start, end) => {
    state.startRow = start;
    state.endRow = end;
};


//COMPOSABLES
const { keyboard } = useKeyboard();



//COMPUTED
const triggerButtonsUpdate = ref(true);
const allowAdd = computed(() => {
    let t = triggerButtonsUpdate.value;
    return common.allowAdd(data, gridApi, state);
});
const allowEdit = computed(() => {
    let t = triggerButtonsUpdate.value;
    return common.allowEdit(data, gridApi, state);
});
const allowDelete = computed(() => {
    let t = triggerButtonsUpdate.value;
    return common.allowDelete(data, gridApi, state);
});
const allowRestore = computed(() => {
    let t = triggerButtonsUpdate.value;
    if (!gridApi || filterRecords.value) {
        return false; // Only allow restore when viewing inactive/deleted references
    }
    
    let selectedNodes = gridApi.getSelectedNodes();
    if (selectedNodes.length === 0) {
        return false;
    }
    
    // Check if all selected references are actually deleted (not just inactive)
    return selectedNodes.every(node => 
        node.data.deleted_at !== null && node.data.deleted_at !== ''
    );
});
const hasActiveReferenceFilters = computed(() => {
    return Object.keys(normalizeReferenceListFilterModel(state.previousFilterModel)).length > 0;
});



//COMPOSABLES
const { common } = useCommon(referenceGrid, state, gridApi2, columnApi2, data);
const { advancedAxios } = useAdvancedAxios(axios);
const { getReferenceDefinition } = useReferenceDefinition(store, dayJs, true); //Third parameter same as defaultColumnDef.floatingFilter initial value
//



const columnDefs = ref([]);
const history = reactive({
    dialog: false,
    model: 'Reference',
    record: null,
    columnDefs: columnDefs,
    prepareRecord: prepareRecord,
    columnDefsOverride: [
        {
            field: 'quantity',
            tooltipComponentParams: null,
            cellClass: null
        },
        {
            field: 'updated_at',
            tooltipComponentParams: null,
            cellClass: null
        }
    ],
    columnDefsDisables: {
        quantity: {}
    }
});
const defaultColDef = reactive({
    resizable: true,
    editable: true,
    sortable: true,
    filter: true,
        floatingFilter: true,
    suppressMenu: false,        //To be set to true, hides filter in header
    filterParams: {
        debounceMs: 500,
        suppressAndOrCondition: true
    },
        floatingFilterComponentParams: {
        suppressFilterButton: false //To be set to true, hides filter button in floating filter
    },
    tooltipComponent: GridTooltip,
    suppressKeyboardEvent: function (params) {
        let event = params.event;
        let key = event.key;
        let deniedKeys = ['Escape'];
        let suppress = params.editing && deniedKeys.indexOf(key) >= 0;
        if (event.key === 'Enter'/* && params.editing==true*/) {
            suppress = true;
        }
        return suppress;
    }
});

// Custom onFilterChanged to prevent client-side filtering
const onFilterChanged = (params) => {
    // Immediately reload data to prevent client-side filtering
    const currentFilterModel = normalizeReferenceListFilterModel(gridApi.getFilterModel());
    if (JSON.stringify(currentFilterModel) !== JSON.stringify(state.previousFilterModel)) {
        state.previousFilterModel = _.cloneDeep(currentFilterModel);
        saveReferenceListSessionPreferences();
        state.isFiltering = true; // Set flag to prevent count updates during filtering
        updatePaginationParams(0, pageSize);
        populateGridWithData();
        gridApi.ensureIndexVisible(0, 'top');
    }
};

const gridOptions = /*reactive(*/{
    ...common.gridOptions,
    noRowsOverlayComponentParams: {
        click: () => { gridApi.hideOverlay(); addNewReference(); }
    },
    
    // Suppress the "No Rows To Show" overlay to keep columns visible
    suppressNoRowsOverlay: true,

    onSortChanged: (e) => {
        //This method keeps the newly added records on top
        common.onSortChanged();
        updatePaginationParams(0, pageSize);
        populateGridWithData();
    },

    onFilterChanged: onFilterChanged,

    onRowDoubleClicked: (params) => {
        if (params.data.id == '') {
            store.addNotificationMessage('Reference: <strong>' + params.data.reference + '</strong> has to be saved first before adding !', 'error');
        } else {
            if (state.isEditing == 'no') {
                state.editingReference = params.data;
                state.containersDialog = true;
            }
        }
    },
    onCellContextMenu: (params) => {
        common.onCellContextMenu(params, gridApi, state);
    },
    onGridReady: (params) => {
        gridApi = params.api;
        gridApi2.value = params.api;
        columnApi = params.columnApi;
        columnApi2.value = params.columnApi;
        initialReferenceListSessionPreferences = hydrateSavedReferenceListSessionPreferences();
        common.onGridReady(params, getReferenceDefinition, columnDefs, state, populateGridWithData);
        applySavedReferenceListSessionPreferences();
    },
    onFirstDataRendered: () => {
        applySavedReferenceListSessionPreferences();
    },
    onRowDataChanged: () => {
        common.onRowDataChanged(columnApi);
        columnApi.autoSizeAllColumns();
    },
    onRowEditingStarted: (params) => {
        triggerButtonsUpdate.value = !triggerButtonsUpdate.value;
        common.onRowEditingStarted(params, state, componentId);
    },
    onRowEditingStopped: (params) => {
        triggerButtonsUpdate.value = !triggerButtonsUpdate.value;
    },
    onRowClicked: (params) => {
        if (params.data.id == "") {
            gridApi.startEditingCell({ rowIndex: params.rowIndex, colKey: state.firstVisibleColumn });
        }
    },
    onCellValueChanged(params) {
        common.onCellValueChanged(params, columnApi);
    },
    onRowValueChanged: (params) => {
        if (params.data.id == '' || common.editedRowChanged(state, params.data)) {
            let validation = validateRecord(params);
            if (validation.valid) {
                params.data.valid = true;

                let method = '';
                let url = '/reference';
                if (params.data.id == '') {
                    method = 'post';
                } else {
                    method = 'put';
                    url += '/' + params.data.id;
                }
                let sendData = { ...params.data };
                //We don't need to send this data
                delete sendData.return_stock_containers__stock_container;
                delete sendData.release_stock_containers__stock_container;
                advancedAxios.sendRequest(componentId + (params.data.id ? params.data.id : params.data.uniqueId), { method: method, url: url, data: sendData })
                    .then(function (response) {
                        if (response.status === 200) {
                            //Update row with changes from backend
                            response.data.model.uniqueId = params.data.uniqueId;
                            response.data.model.valid = true;
                            common.updateChangesFromBackendOnUpdatingRows(response.data.model, gridApi, data, prepareRecord);
                            store.addNotificationMessage('Reference: <strong>' + (params.data.reference != '' ? params.data.reference : '') + '</strong> saved!', 'success');
                        } else {
                            params.data.valid = false;
                            params.node.setDataValue('valid', false);
                        }
                    }).catch(function (error) {
                        if (error.message !== 'canceled') {
                            params.data.valid = false;
                            params.node.setDataValue("valid", false);
                        }
                    });
            } else {
                params.data.valid = false;
                params.node.setDataValue('valid', params.data.valid);
                store.addNotificationMessage(validation.message, 'error');
            }
        }
        state.isEditing = 'no';
        triggerButtonsUpdate.value = !triggerButtonsUpdate.value;
    },

    onSelectionChanged: (params) => {
        triggerButtonsUpdate.value = !triggerButtonsUpdate.value;
    },
    onModelUpdated: (params) => {
        // Only update the count if we're not in the middle of filtering
        // This prevents the client-side filtered count from showing during filtering
        if (!state.isFiltering) {
        totalRecords.value = gridApi ? gridApi.getDisplayedRowCount() : '...';
        }
    },
    onPinnedRowDataChanged: (params) => {
        state.allowUnpin = (data.pinnedTopRowData.length === 0) ? false : true;
    },
    onCellMouseDown: (params) => {
        common.onCellMouseDown(params);
    },
    tabToNextCell(params) {
        return common.tabToNextCell(params, gridApi);
    },
    onBodyScroll: (event) => {
        if (!deactivatingCellEditors && event.direction == 'horizontal') {
            deactivatingCellEditors = true;
            common.deactivateAllCellEditors(gridApi);
            setTimeout(function () { deactivatingCellEditors = false; }, 2000);    //We do this so we don't trigger this method too many times and because bodyScrollEnd is not being triggered
        }
        
        // Handle vertical scrolling for infinite pagination
        if (data.rowData === null || data?.rowData?.length === state?.totalRowCount){
            return;
        }
        const lastRowIndex = data.rowData.length - 1;

        const gridLastRow = gridApi.getLastDisplayedRow();
        if (state.gridReady && gridLastRow >= lastRowIndex - buffer) {
            state.infiniteDataLoading = true;
            // User scrolled to the bottom, load more data
            const newStartRow = state.endRow;
            const newEndRow = newStartRow + pageSize; // Page size, adjust as needed
            updatePaginationParams(newStartRow, newEndRow);
            populateGridWithData();
        }
    },
    onBodyScrollEnd: (event) => {
        //This is currently not working but we will use it once the bug it's fixed by ag-grid developers
        deactivatingCellEditors = false;
    },
    onCellClicked: (params) => {
        common.onCellClicked(params, store);
    }
}



//EVENTS
onBeforeMount(() => {
})
onMounted(() => {
    window.addEventListener('beforeunload', persistReferenceListSessionPreferences);
    window.addEventListener('pagehide', persistReferenceListSessionPreferences);
})
onBeforeUnmount(() => {
    window.removeEventListener('beforeunload', persistReferenceListSessionPreferences);
    window.removeEventListener('pagehide', persistReferenceListSessionPreferences);
})
onActivated(() => {
    keyboard.addListener(componentId, onKeyPressHandler);
    keyboard.activate(componentId);
})

onDeactivated(() => {
    persistReferenceListSessionPreferences();
    keyboard.removeListener(componentId);
})



//METHODS
const onKeyPressHandler = (event) => {
    if (state.containersDialog === false) {
        if (event.shiftKey) {
            if (event.key == '+') { addNewReturnReference(); }
            if (event.key == '-') { addNewReleaseReference(); }
            if (event.key == '*') { store.addNotificationMessage('Reference: has to be saved first before adding !', 'error'); }
        } else {
            common.onKeyPressHandler(event, gridApi, data, state);
        }
    }
}

const populateGridWithData = () => {
    state.gridReady = false;
    setTimeout(() => {
        gridApi.showLoadingOverlay();
        const overlay = document.querySelector('.ag-overlay');
        if (overlay) {
            overlay.style.position = 'absolute';
            overlay.style.top = '97px';
            overlay.style.height = 'calc(100% - 97px)';
            //this is to show column names and filter inputs while loading
        }
    });
    // Build URL with pagination parameters
    let url = '/reference/' + (filterRecords.value ? 'active' : 'inactive');
    url += `?startRow=${state.startRow}&endRow=${state.endRow}`;

    // Get current filter model from ag-grid and add to URL
    let filterModel = normalizeReferenceListFilterModel(gridApi ? gridApi.getFilterModel() : state.previousFilterModel);
    if ((!filterModel || Object.keys(filterModel).length === 0) && hasReferenceListSessionFilterModel(initialReferenceListSessionPreferences)) {
        filterModel = _.cloneDeep(initialReferenceListSessionPreferences.filterModel);
    }
    filterModel = normalizeReferenceFilterModelForServer(filterModel);
    if (Object.keys(filterModel).length > 0) {
        url += '&filters=' + encodeURIComponent(JSON.stringify(filterModel));
    }

    common.normalServerReload(url, axios, state, gridApi, fields, store, modelSubmodelMap, columnDefs, prepareRecord, common.prepareListRecord, data, onReloadSuccessError, onReloadSuccessError, onBeforeSetRowData);
}
const onBeforeSetRowData = (response) => {
    let isoCodes = response.data.models.iso_codes;
    isoCodes = isoCodes.reduce(function (result, item) {
        result[item.code] = {
            stockContainers_in_stock_available_released_count: item.stockContainers_in_stock_available_released_count,
            stockContainers_in_stock_all_count: item.stockContainers_in_stock_all_count,
        }
        return result;
    }, []);
    data.isoCodes = isoCodes;
    
    // Set total row count for pagination display
    if (response.data.totalRows !== undefined) {
        state.totalRowCount = response.data.totalRows;
    }
}
const onReloadSuccessError = (response) => {
    state.gridReady = true;
    triggerButtonsUpdate.value = !triggerButtonsUpdate.value;
    state.infiniteDataLoading = false;
    state.isFiltering = false; // Reset filtering flag
}

const addNewReturnReference = () => {
    addNewReference('return');
}
const addNewReleaseReference = () => {
    addNewReference('release');
}

const addNewReference = (type) => {
    gridApi.setFilterModel(null);
    setTimeout(function () {
        gridApi.hideOverlay();
        state.isAdding = true;
        let newReference = prepareRecord({
            new: 1,
            type: type,
            operator_id: '',
            leasing_company_id: '',
            booking_category_id: ''
        });
        data.rowData.unshift(newReference);
        gridApi.setRowData(data.rowData);
        nextTick(() => {
            let node = gridApi.getRowNode(newReference.uniqueId);
            if (node) {
                gridApi.startEditingCell({ rowIndex: node.rowIndex, colKey: state.firstVisibleColumn });
                state.isEditing = 'existing';
            }
        })
        triggerButtonsUpdate.value = !triggerButtonsUpdate.value;
    }, 1);
}

const editReference = () => {
    gridApi.stopEditing();
    let rows = gridApi.getSelectedNodes();
    if (rows.length > 0) {
        let row = rows[0];
        gridApi.startEditingCell({ rowIndex: row.rowIndex, colKey: state.firstVisibleColumn });
        state.isEditing = 'existing';
    }
}

const deleteReference = () => {
    if (!common.deleteEditingRow(gridApi, data, state)) {
        let nodes = gridApi.getSelectedNodes();
        state.nodesToDelete = [];
        nodes.forEach(item => state.nodesToDelete.push(item));
        state.dialog = true;
    } else {
        triggerButtonsUpdate.value = !triggerButtonsUpdate.value;
    }
}
const confirmDeleteReference = () => {
    state.dialog = false
    let delData = [];
    let max = state.nodesToDelete.length;
    for (let i = 0; i < max; i++) {
        delData.push(state.nodesToDelete[i].data.id);
    }
    axios.delete('/reference/' + delData.join(',')).then(function (response) {
        if (response.status == 200) {
            let deleted = response.data.deleted.length ? response.data.deleted.split(",") : [];
            let max = deleted.length;
            for (let i = 0; i < max; i++) {
                let delIndex = data.rowData.findIndex(o => o.id === parseInt(deleted[i]));
                data.rowData.splice(delIndex, 1)
                gridApi.setRowData(data.rowData)
            }
            state.nodesToDelete = [];
            triggerButtonsUpdate.value = !triggerButtonsUpdate.value;
        } else {
            //
        }
    }).catch(function (error) { });
}
const cancelDeleteReference = () => {
    state.dialog = false
}

const handleDeleteRestore = () => {
    if (filterRecords.value) {
        deleteReference();
    } else {
        restoreReference();
    }
}

const restoreReference = () => {
    let nodes = gridApi.getSelectedNodes();
    if (nodes.length > 0) {
        state.nodesToRestore = [];
        nodes.forEach(item => state.nodesToRestore.push(item));
        state.restoreDialog = true;
    }
}

const confirmRestoreReference = () => {
    state.restoreDialog = false;
    let restoreData = [];
    let max = state.nodesToRestore.length;
    for (let i = 0; i < max; i++) {
        restoreData.push(state.nodesToRestore[i].data.id);
    }
    axios.put('/reference/restore/' + restoreData.join(',')).then(function (response) {
        if (response.status == 200) {
            // Remove restored references from the current view (inactive/deleted list)
            let restored = response.data.restored ? response.data.restored.split(",") : [];
            let max = restored.length;
            for (let i = 0; i < max; i++) {
                let restoreIndex = data.rowData.findIndex(o => o.id === parseInt(restored[i]));
                if (restoreIndex !== -1) {
                    data.rowData.splice(restoreIndex, 1);
                }
            }
            gridApi.setRowData(data.rowData);
            state.nodesToRestore = [];
            triggerButtonsUpdate.value = !triggerButtonsUpdate.value;
            store.addNotificationMessage('Reference restored successfully!', 'success');
        } else {
            store.addNotificationMessage('Failed to restore reference', 'error');
        }
    }).catch(function (error) {
        store.addNotificationMessage('Error restoring reference: ' + error.message, 'error');
    });
}

const cancelRestoreReference = () => {
    state.restoreDialog = false;
}

const cancelEditReference = () => {
    state.dialog = false
}
const finishEditingReference = (cancel = false) => {
    gridApi.stopEditing();
    state.isEditing = 'no';
    triggerButtonsUpdate.value = !triggerButtonsUpdate.value;
}

const exportCsv = () => {
    common.exportCsv(gridApi, {
        processHeaderCallback: function (params) {
            switch (params.column.colId) {
                case 'report':
                    return 'SC Flow Report';
                default:
                    return params.column.colDef.headerName;
            }
        }
    }, {
        processCellCallback: function (cell) {
            if (cell.column.colId == 'receipts') {
                if (cell.node.data.gate_in_date != '' && cell.node.data.gate_out_date == '') {
                    return 'In';
                }
                if (cell.node.data.gate_in_date != '' && cell.node.data.gate_out_date != '') {
                    return 'In/Out';
                }
                return false;
            } else {
                return false;
            }
        }
    });
}

const exportXlsx = () => {
    common.exportXlsx(gridApi, {
        fileName: 'export.xlsx',
        processHeaderCallback: function (params) {
            switch (params.column.colId) {
                case 'report':
                    return 'SC Flow Report';
                default:
                    return params.column.colDef.headerName;
            }
        }
    }, {
        processCellCallback: function (cell) {
            if (cell.column.colId == 'receipts') {
                if (cell.node.data.gate_in_date != '' && cell.node.data.gate_out_date == '') {
                    return 'In';
                }
                if (cell.node.data.gate_in_date != '' && cell.node.data.gate_out_date != '') {
                    return 'In/Out';
                }
                return false;
            } else {
                return false;
            }
        }
    });
}

const toggleFilter = () => {
    filterRecords.value = !filterRecords.value;
    let found = columnDefs.value.find((item) => {
        return item.field == 'reference_status'
    })
    if (found) {
        found.hide = filterRecords.value;
    }

    // Clear all filters when toggling between active and inactive views
    if (gridApi) {
        gridApi.setFilterModel(null);
    }

    saveReferenceListSessionPreferences();

    // Reset pagination when toggling filter
    updatePaginationParams(0, pageSize);
    common.reloadHandler(state, data, populateGridWithData);
}

const normalizeReferenceFilterModelForServer = (filterModel = {}) => {
    return Object.entries(filterModel).reduce((normalizedModel, [field, filter]) => {
        if (!_.isPlainObject(filter)) {
            normalizedModel[field] = filter;
            return normalizedModel;
        }

        if (!Object.prototype.hasOwnProperty.call(filter, 'filter') && Object.prototype.hasOwnProperty.call(filter, 'value')) {
            normalizedModel[field] = {
                ...filter,
                filter: filter.value,
            };
            return normalizedModel;
        }

        normalizedModel[field] = filter;
        return normalizedModel;
    }, {});
};

const clearReferenceFilters = () => {
    if (!gridApi) {
        return;
    }

    state.isFiltering = true;
    state.previousFilterModel = {};
    initialReferenceListSessionPreferences = {
        ...getReferenceListSessionPreferences(),
        filterModel: {},
        filterRecords: !!filterRecords.value,
    };

    gridApi.setFilterModel(null);
    saveReferenceListSessionPreferences();
    updatePaginationParams(0, pageSize);
    common.reloadHandler(state, data, populateGridWithData);
    gridApi.ensureIndexVisible(0, 'top');
}

const numberComparator = (a, b) => {
    return a - b;
}

const closeContainersDialog = () => {
    state.containersDialog = false;
}

const closeHistoryDialog = () => {
    history.dialog = false;
}

const dataUpdateContainers = (updateData) => {
    let row = data.rowData.find(item => item.id == updateData.referenceId);
    if (!row) {
        row = data.pinnedTopRowData.find(item => item.id == updateData.referenceId);
    }
    if (row) {
        if (row.type == 'return') {
            row.return_stock_containers__stock_container = updateData.containers;
        } else {
            row.release_stock_containers__stock_container = updateData.containers;
        }
        gridApi.setRowData(data.rowData);
    }
}

const stopEditingOnRightClick = () => {
    common.stopEditingOnRightClick(state, gridApi)
}

const showHistory = () => {
    let rows = gridApi.getSelectedNodes();
    if (rows.length > 0) {
        history.record = rows[0].data;
        history.dialog = true;
    }
}

function prepareRecord(item) {
    return {
        ...common.prepareRecord(item)
        ,
        ...{
            valid: item.valid || true,
            actions: item.actions || '',
            id: item.id || '',
            type: item.type || 'return',
            reference: item.reference || '',
            created: item.created || '',
            validity: item.validity || '',
            quantity: item.quantity || '',
            survey_size_type_id: item.survey_size_type_id || null,
            iso_type_ids: item.iso_type_ids || (item.iso_types ? item.iso_types.map(t => t.code) : []),
            iso_types: item.iso_types || [],
            operator_id: item.operator_id || item.operator_id === null ? item.operator_id : '',
            leasing_company_id: item.leasing_company_id || item.leasing_company_id === null ? item.leasing_company_id : '',
            depot_id: item.depot_id || null,
            freight_kind: item.freight_kind || null,
            cargo_condition_id: item.cargo_condition_id || null,
            transport_status_id: item.transport_status_id || null,
            booking_category_id: item.booking_category_id || null,
            container_older: item.container_older || null,
            container_younger: item.container_younger || null,
            updated_at: item.updated_at || '',
            created_at: item.created_at || '',
            deleted_at: item.deleted_at || null,
            comment: item.comment || '',
            condition: item.condition || null,
            created_by: _.get(item, 'created_by__user.name') || null,
            created_from: item.created_from || '',
            return_stock_containers__stock_container: item.return_stock_containers__stock_container || [],
            release_stock_containers__stock_container: item.release_stock_containers__stock_container || [],
            reference_status: item.deleted_at !== null ? 'Deleted' : ( dayJs(item.validity).isValid() && dayJs(item.validity).isAfter(dayJs.utc()) ? 'Active' : 'Inactive'),
            available_quantity: 
                (data.isoCodes[item.survey_size_type_id] ? data.isoCodes[item.survey_size_type_id]['stockContainers_in_stock_available_released_count'] : 0)
                + '/' +
                (data.isoCodes[item.survey_size_type_id] ? data.isoCodes[item.survey_size_type_id]['stockContainers_in_stock_all_count'] : 0),
        }
    }
}

const validateRecord = (params) => {
    let valid = true;
    //To validate use: let valid = ReferenceListValidator.validate(params.data);
    if (valid !== true) {
        return {
            valid: false,
            message: valid
        }
    } else {
        return {
            valid: true
        }
    }
}

const modelSubmodelMap = {
    model: {
        'reference': { prepareRecord: prepareRecord, target: () => { if (data.rowData === null) { data.rowData = []; } return data.rowData } }
    },
    submodels: {
        'survey_size_type_id': { id: 'code', name: ['code', 'survey_type__survey_type.name'], prepareRecord: common.prepareListRecord, target: function () { return columnDefs.value.find(def => def.field === 'survey_size_type_id').cellEditorParams.valueList } },
        'transport_status_id': { prepareRecord: common.prepareListRecord, target: function () { return columnDefs.value.find(def => def.field === 'transport_status_id').cellEditorParams.valueList } },
        'cargo_condition_id': { id: 'code', prepareRecord: common.prepareListRecord, target: function () { return columnDefs.value.find(def => def.field === 'cargo_condition_id').cellEditorParams.valueList } },
        'booking_category_id': { prepareRecord: common.prepareListRecord, target: function () { return columnDefs.value.find(def => def.field === 'booking_category_id').cellEditorParams.valueList } },
        'operator_id': { prepareRecord: common.prepareListRecord, target: function () { return columnDefs.value.find(def => def.field === 'operator_id').cellEditorParams.valueList } },
        'depot_id': { prepareRecord: common.prepareListRecord, target: function () { return columnDefs.value.find(def => def.field == 'depot_id').cellEditorParams.valueList } },
        'leasing_company_id': { prepareRecord: common.prepareListRecord, target: function () { return columnDefs.value.find(def => def.field === 'leasing_company_id').cellEditorParams.valueList } },
        'type': { prepareRecord: common.prepareListRecord, target: function () { return columnDefs.value.find(def => def.field === 'type').cellEditorParams.valueList } },
        'inspection_criteria': { prepareRecord: common.prepareListRecord, target: function () { return columnDefs.value.find(def => def.field === 'inspection_criteria').cellEditorParams.valueList } },
        'freight_kind': { prepareRecord: common.prepareListRecord, target: function () { return columnDefs.value.find(def => def.field === 'freight_kind').cellEditorParams.valueList } },
        'created_from': { prepareRecord: common.prepareListRecord, target: function () { return columnDefs.value.find(def => def.field === 'created_from').cellEditorParams.valueList } }
    }
};

</script>

<style lang="sass">
.filters-disabled
    :deep(.ag-header-cell-menu-button),
    :deep(.ag-floating-filter),
    :deep(.ag-floating-filter-button)
        pointer-events: none

    :deep(.ag-header-cell-menu-button),
    :deep(.ag-floating-filter-body input),
    :deep(.ag-floating-filter-button-button)
        cursor: wait
</style>

<script>
export default {
    name: 'ReferenceList',
    customOptions: {}
}
</script>
